/**
 * ============================================================================
 * 1MDEAL CUSTOM JAVASCRIPT FOR SHOPIFY DAWN THEME
 * 
 * INSTALLATION:
 * 1. Go to: Online Store > Themes > Actions > Edit Code
 * 2. Click on Assets folder
 * 3. Click "Add a new asset"
 * 4. Select "Create a blank file"
 * 5. Name it: custom-1mdeal.js
 * 6. Paste this entire code
 * 7. Click SAVE
 * 
 * THEN LINK IT:
 * 8. Go to Layout > theme.liquid
 * 9. Find </body> tag (near bottom)
 * 10. Add this line BEFORE </body>:
 *     <script src="{{ 'custom-1mdeal.js' | asset_url }}" defer></script>
 * 11. Click SAVE
 * ============================================================================
 */

(function() {
    'use strict';

    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', function() {
        initializeDealFunctionality();
        initializeFAQ();
        initializeProgressBars();
        initializeShareButtons();
        initializeCountdownTimers();
        initializeNotifications();
    });

    /**
     * Initialize Deal Claiming Functionality
     */
    function initializeDealFunctionality() {
        const claimButtons = document.querySelectorAll('.btn-claim-deal');
        
        claimButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                const productId = this.dataset.productId;
                const productTitle = this.dataset.productTitle;
                
                // Show notification
                showNotification(`🎉 Claiming: ${productTitle}! Adding to cart...`);
                
                // In Shopify, this would add to cart
                // The actual add to cart is handled by Shopify's built-in functionality
            });
        });
    }

    /**
     * Initialize FAQ Accordion
     */
    function initializeFAQ() {
        const faqItems = document.querySelectorAll('.faq-item');
        
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            
            if (question) {
                question.addEventListener('click', function() {
                    // Close all other FAQs
                    faqItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
                    
                    // Toggle current FAQ
                    item.classList.toggle('active');
                });
            }
        });
    }

    /**
     * Initialize Progress Bars Animation
     */
    function initializeProgressBars() {
        const progressBars = document.querySelectorAll('.progress-fill');
        
        // Animate progress bars when they come into view
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const target = entry.target;
                    const targetWidth = target.dataset.progress || '0';
                    
                    setTimeout(() => {
                        target.style.width = targetWidth + '%';
                    }, 200);
                    
                    observer.unobserve(target);
                }
            });
        }, { threshold: 0.1 });
        
        progressBars.forEach(bar => {
            // Store the target width and start at 0
            bar.dataset.progress = bar.style.width.replace('%', '');
            bar.style.width = '0%';
            observer.observe(bar);
        });
    }

    /**
     * Initialize Share Buttons
     */
    function initializeShareButtons() {
        const shareButtons = document.querySelectorAll('.btn-share-deal');
        
        shareButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const url = this.dataset.shareUrl || window.location.href;
                const title = this.dataset.shareTitle || document.title;
                
                // Try native Web Share API first
                if (navigator.share) {
                    navigator.share({
                        title: title,
                        text: 'Check out this amazing deal on 1MDEAL!',
                        url: url
                    }).catch(err => {
                        console.log('Share cancelled');
                    });
                } else {
                    // Fallback: Copy to clipboard
                    copyToClipboard(url);
                    showNotification('✓ Link copied to clipboard!');
                }
            });
        });
    }

    /**
     * Initialize Countdown Timers
     */
    function initializeCountdownTimers() {
        const timers = document.querySelectorAll('.countdown-timer');
        
        timers.forEach(timer => {
            const endDate = new Date(timer.dataset.endDate);
            
            function updateTimer() {
                const now = new Date();
                const distance = endDate - now;
                
                if (distance < 0) {
                    timer.innerHTML = '<strong>Deal Ended</strong>';
                    return;
                }
                
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                
                if (days > 0) {
                    timer.innerHTML = `<strong>${days}d ${hours}h</strong> left`;
                } else if (hours > 0) {
                    timer.innerHTML = `<strong>${hours}h ${minutes}m</strong> left`;
                } else {
                    timer.innerHTML = `<strong>${minutes}m ${seconds}s</strong> left`;
                }
            }
            
            updateTimer();
            setInterval(updateTimer, 1000);
        });
    }

    /**
     * Show Notification
     */
    function showNotification(message, type = 'success') {
        // Remove existing notifications
        const existing = document.querySelector('.notification-1mdeal');
        if (existing) {
            existing.remove();
        }
        
        const notification = document.createElement('div');
        notification.className = 'notification-1mdeal notification-' + type;
        notification.textContent = message;
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: ${type === 'success' ? '#10b981' : '#ef4444'};
            color: white;
            padding: 1rem 1.5rem;
            border-radius: 8px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.2);
            z-index: 10000;
            animation: slideIn 0.3s ease;
            max-width: 400px;
            font-weight: 600;
        `;
        
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.style.animation = 'slideOut 0.3s ease';
            setTimeout(() => {
                notification.remove();
            }, 300);
        }, 3000);
    }

    /**
     * Initialize Notification System
     */
    function initializeNotifications() {
        // Add animation styles if not already present
        if (!document.getElementById('notification-styles-1mdeal')) {
            const style = document.createElement('style');
            style.id = 'notification-styles-1mdeal';
            style.textContent = `
                @keyframes slideIn {
                    from {
                        transform: translateX(400px);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
                
                @keyframes slideOut {
                    from {
                        transform: translateX(0);
                        opacity: 1;
                    }
                    to {
                        transform: translateX(400px);
                        opacity: 0;
                    }
                }
            `;
            document.head.appendChild(style);
        }
    }

    /**
     * Copy to Clipboard Helper
     */
    function copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    /**
     * Update Progress Bar based on Shopify Product Data
     */
    function updateProgressBar(productId, claimed, target) {
        const progressBar = document.querySelector(`[data-product-id="${productId}"] .progress-fill`);
        const progressText = document.querySelector(`[data-product-id="${productId}"] .progress-text`);
        
        if (progressBar && progressText) {
            const percentage = Math.round((claimed / target) * 100);
            progressBar.style.width = percentage + '%';
            progressText.innerHTML = `<span><strong>${claimed}/${target}</strong> claimed</span><span>${percentage}%</span>`;
        }
    }

    /**
     * Initialize Scroll Animations
     */
    const animateOnScroll = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-fade-in-up');
            }
        });
    }, { threshold: 0.1 });

    // Observe elements for animation
    document.querySelectorAll('.step-card, .deal-card-1mdeal, .benefit-card, .testimonial-card').forEach(el => {
        animateOnScroll.observe(el);
    });

    /**
     * Smooth Scroll for Anchor Links
     */
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href !== '#' && href !== '#!') {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });

    /**
     * Newsletter Form Handler
     */
    const newsletterForms = document.querySelectorAll('.newsletter-1mdeal');
    newsletterForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = form.querySelector('input[type="email"]').value;
            
            // Here you would integrate with Shopify's customer API or email service
            showNotification('Thank you for subscribing! 🎉');
            form.reset();
        });
    });

    /**
     * Mobile Menu Enhancement (if needed beyond Dawn's default)
     */
    function enhanceMobileMenu() {
        const mobileMenuButton = document.querySelector('.header__icon--menu');
        if (mobileMenuButton) {
            // Add any custom mobile menu behavior here
        }
    }

    enhanceMobileMenu();

    /**
     * Add to Cart with Custom Messaging
     */
    document.addEventListener('click', function(e) {
        if (e.target.matches('.product-form__submit')) {
            setTimeout(() => {
                showNotification('🎉 Deal claimed! Item added to cart!');
            }, 500);
        }
    });

    /**
     * Initialize Deal Statistics
     */
    function initializeDealStats() {
        const statNumbers = document.querySelectorAll('.stat-number');
        
        statNumbers.forEach(stat => {
            const target = parseInt(stat.textContent);
            let current = 0;
            const increment = target / 50;
            const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                    stat.textContent = target.toLocaleString();
                    clearInterval(timer);
                } else {
                    stat.textContent = Math.floor(current).toLocaleString();
                }
            }, 20);
        });
    }

    // Initialize stats when they come into view
    const statsObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initializeDealStats();
                statsObserver.unobserve(entry.target);
            }
        });
    });

    const heroStats = document.querySelector('.hero-stats');
    if (heroStats) {
        statsObserver.observe(heroStats);
    }

    /**
     * Console Welcome Message
     */
    console.log('%c1MDEAL Custom Scripts Loaded! ', 'background: #6366f1; color: white; padding: 10px; border-radius: 5px; font-size: 14px;');
    console.log('Everyone wins or the deal\'s cancelled! 🎉');

})();

/**
 * ============================================================================
 * END OF 1MDEAL CUSTOM JAVASCRIPT
 * ============================================================================
 */